module.exports = __webpack_public_path__ + "static/media/bottom-background.eb3a9c61.svg";